module.exports = __webpack_public_path__ + "img/link_upload_icon.fe1e6a5c.svg";